import { render, staticRenderFns } from "./TemplateBody.vue?vue&type=template&id=a1c0d154&scoped=true&"
import script from "./TemplateBody.vue?vue&type=script&lang=ts&"
export * from "./TemplateBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0d154",
  null
  
)

export default component.exports